<template>
  <!-- 智慧学答题作答通用模版 -->
  <div class="answer-exercise-container dialog-exercise" v-if="isTrue">
    <div class="title" v-if="isTabShow">
      <div
        class="title-item"
        v-for="(n, i) in exerciseList"
        :key="i"
        :class="{ itemed: n.result == 1, texted: i === exerciseIndex }"
        @click="onIndex(i)"
      >
        {{ i + 1 }}
      </div>
    </div>
    <div class="answer-exercise-content" :style="styleObject">
      <div class="stem" v-html="dataIng.question.topic"></div>
      <div
        class="stem"
        v-html="dataIng.question.subtitle"
        v-if="dataIng.question.subtitle"
      ></div>
      <div class="options-box">
        <el-radio-group v-model="dataIng.user_answer_index" disabled>
          <div
            class="options flex-between"
            v-for="(item, index) in dataIng.question.option"
            :key="index"
            :class="
              index == dataIng.user_answer_index
                ? `result_${dataIng.result}`
                : ''
            "
          >
            <el-radio :label="index">{{ index | optionText }}</el-radio>
            <div class="item" v-html="item"></div>
          </div>
        </el-radio-group>
      </div>
      <div class="explain-box clearfix">
        【答案】：
        <span class="explain-answers" v-html="dataIng.question.answer"></span>
      </div>
      <div class="explain-box clearfix">
        <!-- 【解析】： -->
        <div v-html="dataIng.question.analysis" class="explain"></div>
      </div>
    </div>
    <div class="footer-box clearfix" v-if="exerciseListCount > 1">
      <div class="footer">
        <el-button
          type="primary"
          round
          @click="onLast"
          :disabled="exerciseIndex === 0"
          >上一题</el-button
        >
        <el-button type="danger" round v-if="false">确认完成</el-button>
        <el-button
          type="primary"
          round
          @click="onNext"
          :disabled="exerciseIndex === exerciseListCount - 1"
          >下一题</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/dialog.css";
export default {
  name: "ziHuiXueLooksAnswerExercise",
  data() {
    return {
      isTrue: false,
      dataIng: {},
      userAnswerIndex: -1,
      userExercise: [],
      exerciseIndex: 0,
      exerciseListCount: 0,
      styleObject: { height: "300px" },
    };
  },
  props: {
    exerciseList: Array,
    isTabShow: Boolean,
    index: Number,
    height: String,
  },
  watch: {
    index() {
      this.init();
    },
    exerciseList() {
      this.init();
    },
    dataIng(){
      this.mathJaxInit();
    }
  },
  created() {
    this.styleObject.height = this.height || "300px";
    this.init();
  },
  filters: {
    optionText(i) {
      let data = ["A", "B", "C", "D","E","F","G","H","I","J","K"];
      return data[i] + ".";
    },
  },
  methods: {
    init() {
      this.exerciseIndex = this.index;
      this.dataIng = this.exerciseList[this.exerciseIndex];
      this.exerciseListCount = this.exerciseList.length;
      this.isTrue = Object.keys(this.dataIng).length > 0;
    },
    onLast() {
      if (this.exerciseIndex > 0) {
        --this.exerciseIndex;
        this.dataIng = this.exerciseList[this.exerciseIndex];
      }
    },
    onNext() {
      if (this.exerciseIndex < this.exerciseList.length - 1) {
        ++this.exerciseIndex;
        this.dataIng = this.exerciseList[this.exerciseIndex];
      }
    },
    onIndex(i) {
      this.exerciseIndex = i;
      this.dataIng = this.exerciseList[this.exerciseIndex];
    },
    mathJaxInit() {
      setTimeout(() => {
        this.$nextTick(function() {
          //这里要注意，使用$nextTick等组件数据渲染完之后再调用MathJax渲染方法，要不然会获取不到数据
          if (this.commonsVariable.isMathjaxConfig) {
            //判断是否初始配置，若无则配置。
            this.commonsVariable.initMathjaxConfig();
          }
          this.commonsVariable.MathQueue("question-id"); //传入组件id，让组件被MathJax渲染
        });
      }, 500);
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.answer-exercise-container .title {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.answer-exercise-container .title .title-item {
  width: 30px;
  height: 30px;
  background-color: #f76570;
  margin: 0 10px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  cursor: pointer;
}
.answer-exercise-container .title .itemed {
  background-color: #6ee4af !important;
}
.answer-exercise-container .title .texted {
  color: #040300 !important;
}
.answer-exercise-content {
  overflow-y: auto;
}
.answer-exercise-content .stem {
  padding-bottom: 5px;
}
.answer-exercise-content .explain-box {
  width: 100%;
  margin-top: 20px;
}
.answer-exercise-content .explain {
  margin-top: 5px;
}
.explain-answers {
  display: inline-block;
}
.answer-exercise-content .options {
  /* width: 100%; */
  position: relative;
  margin: 5px 0;
  padding: 0 10px;
}
.el-radio,
.radio-group-box {
  width: 98%;
}
.answer-exercise-content .item {
  margin: 4px 0;
  min-width: 700px;
  display: inline-block;
  padding: 10px 5px;
}
.answer-exercise-content .options:hover {
  box-shadow: 0px 1px 10px #f0f0f0;
}
.answer-exercise-content .footer-box {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.answer-exercise-container .footer {
  text-align: center;
  margin: 20px auto;
}
.answer-exercise-container .footer button {
  margin: 0 20px;
}
.answer-exercise-content .m-10 {
  margin: 0 10px;
}
.answer-exercise-content .success {
  background-color: #6fe7b3;
  color: #fff;
}
.answer-exercise-content .error {
  background-color: #f76570;
  color: #fff;
}

.result_1 {
  background-color: #6fe7b3;
}
.result_0 {
  background-color: #f76570;
}
.flex-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
